import React, { Component } from "react";
import Head from "next/head";
import { connect } from "react-redux";
import withRouterPageLayout from "@components/withRouterPageLayout.js";

import {
  getSupportCategories,
  getSupportCategoryArticles,
} from "@store/support/actions";
import ErrorPage from "@containers/ErrorPage";
import SupportLayout from "@containers/Support/Layout";
import Breadcrumbs from "@components/Breadcrumbs";
import Heading from "@components/Heading";

import ArticleCard from "@containers/Support/ArticleCard";
import RelatedArticles from "@containers/Support/RelatedArticles";

class SupportCategoryPage extends Component {
  render() {
    const {
      supportCategoryName,
      supportCategories,
      supportArticle,
      supportParent,
      supportArticleFaqs,
      supportArticleRelated,
    } = this.props;

    if (!supportCategories || !supportArticle) {
      return <ErrorPage layout="404" />;
    }

    return (
      <>
        <Head>
          <title>{`${supportParent?.name} — ${supportCategoryName}`}</title>
        </Head>

        <Breadcrumbs
          breadcrumbs={[
            {
              id: 1,
              level: 2,
              name: `Suport clienti`,
              url_key: "suport-clienti/",
            },
            {
              id: 1,
              level: 99,
              name: `${supportParent.name} — ${supportCategoryName}`,
            },
          ]}
        />

        <SupportLayout categories={supportCategories}>
          <section className="pb-6 lg:py-6">
            {
              <>
                <div className="lg:flex">
                  <div className="lg:w-2/3 lg:pr-6">
                    <div className="mb-6 lg:pt-4">
                      <Heading
                        title={supportCategoryName}
                        as="h1"
                        display="h1"
                        classesProp="text-left mb-2 mt-4 lg:mt-0"
                      />
                    </div>

                    <ArticleCard
                      key={supportArticle.slug}
                      item={supportArticle}
                      articleSlug={supportArticle.slug}
                    />

                    {supportArticleFaqs && !!supportArticleFaqs.length && (
                      <section className="mt-12">
                        <div className="mb-6">
                          <Heading
                            title={`Intrebari frecvente`}
                            as="h2"
                            display="h2"
                          />
                        </div>

                        {supportArticleFaqs.map((item) => (
                          <ArticleCard
                            key={item.slug}
                            item={item}
                            articleSlug={item.slug}
                          />
                        ))}
                      </section>
                    )}
                  </div>

                  {supportArticleRelated && !!supportArticleRelated.length && (
                    <div className="lg:w-1/3" style={{ minWidth: "305px" }}>
                      <RelatedArticles items={supportArticleRelated} />
                    </div>
                  )}
                </div>
              </>
            }
          </section>
        </SupportLayout>
      </>
    );
  }
}

SupportCategoryPage.getInitialProps = async (ctx) => {
  const { reduxStore, query, res } = ctx;
  const { categoryUrlKey } = query;

  // Get data from store
  const { categories } = reduxStore.getState().support;

  // Load data
  !categories && (await reduxStore.dispatch(getSupportCategories()));
  const articleRes = await reduxStore.dispatch(
    getSupportCategoryArticles(categoryUrlKey)
  );

  if (!articleRes && res) {
    res.statusCode = 404;
  }

  return {
    categoryUrlKey,
  };
};

SupportCategoryPage.pageLayout = "default";
SupportCategoryPage.layoutProps = {
  displaySearch: false,
};

export default withRouterPageLayout(
  connect((state) => ({
    supportCategoryName: state.support.categoryName,
    supportCategories: state.support.categories,
    supportArticle: state.support.article,
    supportParent: state.support.parent,
    supportArticleFaqs: state.support.articleFaqs,
    supportArticleRelated: state.support.articleRelated,
  }))(SupportCategoryPage)
);
